import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error Could not find a declaration file for module
import TrackCompleteInterstitial from '../../components/ContentInterstitials/PostTrackInterstitial/TrackCompleteInterstitial';
// @ts-expect-error Could not find a declaration file for module
import TrackIncompleteInterstitial from '../../components/ContentInterstitials/PostTrackInterstitial/TrackIncompleteInterstitial';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking';
import TrackIntroductionInformation from '../../components/TrackPage/TrackIntroductionInformation';
import { HasParentPlaylist, NextPlaylistContent } from '../../features/playlistContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackFinishedPageContainer = ({
  track,
  trackProgress
}) => {
  const trackIsComplete = (trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.status) === 'COMPLETED';
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: SUB_SCREENS.CONCLUSION,
      trackId: track.id,
      trackIsComplete
    });
  }, [track.id, trackIsComplete]);
  return /*#__PURE__*/_jsxs("div", {
    children: [trackIsComplete ? /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_CONCLUSION_COMPLETE_VIEW_LOADED",
      children: /*#__PURE__*/_jsx(HasParentPlaylist, {
        fallback: /*#__PURE__*/_jsx(TrackCompleteInterstitial, {}),
        children: /*#__PURE__*/_jsx(NextPlaylistContent, {
          render: ({
            url,
            showPlaylistNavigatorCta
          }) => /*#__PURE__*/_jsx(TrackCompleteInterstitial, {
            buttonI18n: showPlaylistNavigatorCta ? 'learningCenter.tracks.interstitials.next' : undefined,
            buttonLink: showPlaylistNavigatorCta ? url : undefined,
            hideButton: !showPlaylistNavigatorCta
          }),
          trackId: track.id
        })
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "COURSE_CONCLUSION_INCOMPLETE_VIEW_LOADED",
        children: /*#__PURE__*/_jsx(HasParentPlaylist, {
          fallback: /*#__PURE__*/_jsx(TrackIncompleteInterstitial, {}),
          children: /*#__PURE__*/_jsx(NextPlaylistContent, {
            render: ({
              url,
              showPlaylistNavigatorCta
            }) => /*#__PURE__*/_jsx(TrackIncompleteInterstitial, {
              buttonI18n: showPlaylistNavigatorCta ? 'learningCenter.tracks.interstitials.next' : undefined,
              buttonLink: showPlaylistNavigatorCta ? url : undefined,
              hideButton: !showPlaylistNavigatorCta
            }),
            trackId: track.id
          })
        })
      }), /*#__PURE__*/_jsx(TrackIntroductionInformation, {
        track: track
      })]
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_CONCLUSION_VIEW_LOADED"
    })]
  });
};
export default TrackFinishedPageContainer;